// extracted by mini-css-extract-plugin
export var aiStarSpin = "_m9-1";
export var spinner = "_m9-0";